<template>
  <!-- 薪酬查看  -->
  <div class="dashboard-container">
    <div class="app-container">
      <el-card shadow="never">
        <el-form class="demo-form-inline" label-position="right" label-width="120px">
          <el-row :gutter="2">
            <el-col :span="6">
              <el-form-item label="教师姓名:">
                <el-input v-model="formState.teacherName" placeholder="请输入教师姓名" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="年:">
                <el-date-picker v-model="formState.salaryYear" type="year" value-format="yyyy" placeholder="选择年">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="月:" class="month_selection_box">
                <el-date-picker v-model="formState.salaryMonth" type="month" format="M月" value-format="MM"
                  popper-class="picker_month_select" placeholder="选择月份">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button @click="seachClear" class="btns" size="small" icon="el-icon-close">清除</el-button>
                <el-button type="primary" @click="seachRest" size="small" class="btns" icon="el-icon-search">搜索</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table style="margin-top: 20px;" height="500" :data="salaryList" :stripe="true" border :highlight-current-row="true">
          <el-table-column prop="salaryMonth" label="月份" width="60"></el-table-column>
          <el-table-column prop="basicSalary" label="底薪"></el-table-column>
          <el-table-column prop="dutyClassFee" label="义务课时费" width="100"></el-table-column>
          <el-table-column prop="monthClassNum" label="当月课时数" width="100"></el-table-column>
          <el-table-column prop="monthClassFee" label="当月课时费" width="100"></el-table-column>
          <el-table-column prop="exceClassNum" label="超出课时数" width="100"></el-table-column>
          <el-table-column prop="extraCalssFee" label="超出课时费" width="100"></el-table-column>
          <el-table-column prop="oneManyClassNum" label="一对多课数" width="100"></el-table-column>
          <el-table-column prop="oneManyClassFee" label="一对多奖励" width="100"></el-table-column>
          <el-table-column prop="exceFiveClassNum" label="本月日超五节课天数" width="160"></el-table-column>
          <el-table-column prop="exceFiveClassFee" label="超出部分奖金" width="120"></el-table-column>
          <el-table-column prop="gradeOneManyFee" label="小学生一对多奖励" width="140"></el-table-column>
          <el-table-column prop="isAlreadyRecommenderFee" label="内推奖励" width="140"></el-table-column>
          <el-table-column prop="vipTotalClassFee" label="会员总课数奖励" width="120"></el-table-column>
          <el-table-column prop="personalSocialSecurity" label="社保补贴" width="100"></el-table-column>
          <el-table-column prop="providentFundSubsidy" label="公积金补贴" width="100"></el-table-column>
          <el-table-column prop="individualIncomeTax" label="个税"></el-table-column>
          <el-table-column prop="boardLodgingExpenses" label="住宿费"></el-table-column>
          <el-table-column prop="boarder" label="伙食费"></el-table-column>
          <el-table-column prop="total" label="应发工资"></el-table-column>
          <el-table-column prop="actualPayroll" label="实发工资"></el-table-column>
          <!-- <el-table-column prop="total" label="总计"></el-table-column> -->
          <el-table-column label="操作" fixed="right" width="150">
            <template slot-scope="scope">
              <el-button @click="editInfo(scope.row, '查看')" type="text">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="formState.pageNum" :page-size="formState.pageSize" layout="prev, pager, next,sizes, jumper"
          :total="totalNum">
        </el-pagination>
      </el-card>
      <salary-dialog ref="salaryMoudel" v-if="isShowDialog" :childTeacherId="parentTeacherId" :editOrview="editOrview"
        @isShowBtn="isShowBtn"></salary-dialog>
    </div>
  </div>
</template>
<script>
import salaryDialog from "./components/salaryEdit.vue"
import { getListSalary } from "@/api/salaryapi"
export default {
  components: {
    salaryDialog,
  },
  data () {
    return {
      isShowDialog: false,
      editOrview: false,
      formState: {
        pageNum: 1,
        pageSize: 10,
        teacherName: "",
        salaryYear: "",
        salaryMonth: "",
      },
      totalNum: 0,
      salaryList: [],
      parentTeacherId: "",
    }
  },
  created () {
    this.getList();
  },
  methods: {
    getList () {
      getListSalary(this.formState).then((res) => {
        console.log(res);
        this.salaryList = res.data.records
        console.log(this.salaryList,'1');
        this.totalNum = res.data.total
      })
    },
    editInfo (row, val) {
      // this.editOrview = false
      this.isShowDialog = true
      this.parentTeacherId = row.id
    },
    seachClear () {
      this.formState = {
        pageNum: 1,
        pageSize: 10,
        teacherName: "",
        salaryYear: "",
        salaryMonth: "",
      }
      this.getList()
    },
    seachRest () {
      console.log(this.formState);
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.formState.pagesize = pageSize;
      this.getList();
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.formState.pageNum = newPage;
      this.getList();
    },
    isShowBtn () {
      this.isShowDialog = false
    },
  }

};
</script>

<style scoped>
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 7px;
  vertical-align: top;
  margin-bottom: 19px;
}

::v-deep.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 5px 0 0 !important;
  box-sizing: border-box;
}


/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.el-dialog {
    width: 70% !important;
  }
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/salary/mysalary.vue